import "./SystemIntegrations.module.css";
import Header from "@/reusable_sections/Header";
import Integration from "./sections/Integration";
import Interactiveintegrationdashboard from "./sections/Interactiveintegrationdashboard";
import Value from "./sections/Value";
import Footer from "@/reusable_sections/Footer";
export default function SystemIntegrationsPage() {
  return <div>
      <Header />
      <Integration />
      <Interactiveintegrationdashboard />
      <Value />
      <Footer />
    </div>;
}